// A place's own arrival circle in a day plan, for places the default circle does not fit - a dam
// or a safari needs a bigger one, a shop in town a smaller one. Blank keeps the Tracking Settings
// circle. The server ignores anything outside these limits, so the editors flag it before saving.
export const PLACE_CIRCLE_MIN = 100;
export const PLACE_CIRCLE_MAX = 3000;

export const PLACE_CIRCLE_HINT = `Own arrival circle in metres (${PLACE_CIRCLE_MIN}-${PLACE_CIRCLE_MAX}). Blank uses the Tracking Settings circle.`;

/** The circle to save, or null to leave the place on the default. */
export function placeCircleForSave(value) {
  if (value === "" || value == null) return null;
  const metres = Math.round(Number(value));
  return Number.isFinite(metres) && metres >= PLACE_CIRCLE_MIN && metres <= PLACE_CIRCLE_MAX ? metres : null;
}

export function placeCircleInvalid(value) {
  return value !== "" && value != null && placeCircleForSave(value) == null;
}

/** The location as saved: its own circle only when it has a usable one. */
export function withPlaceCircle(location, value) {
  const circle = placeCircleForSave(value);
  return circle == null ? location : { ...location, arrivalRadiusM: circle };
}
